<template>
	<v-container fluid tag="section">
		<v-row class="mb-6">
			<v-col cols="12">
				<v-card>
					<div class="d-flex pa-5">
						<div class="d-flex justify-start flex-column">
							<v-icon size="80" dark :color="color" v-html="icon"></v-icon>
						</div>
						<div class="">
							<div class="d-flex flex-column justify-start" style="font-size: 20px;height: 100%;" :class="[color === 'orange' ? 'orange--text' : 'red--text']">
								<div class="pt-5">
									{{ message }}
								</div>
								<p style="white-space: pre-wrap;line-height: 35px;color: grey;padding: 15px 0;" v-if="rejectReason">
									{{ rejectReason }}
								</p>
							</div>
						</div>
					</div>
					<div class="text-center mt-3 pb-10">
						<v-btn large color="secondary" @click="showProfile()">ویرایش اطلاعات پروفایل</v-btn>
					</div>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogUser" scrollable persistent max-width="1100px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات کاربر</span>
					<v-spacer />
					<v-btn @click="dialogUser = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-profile ref="modifyProfile" :data="selectedUser" @callbck="callbck_userprofile" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</v-container>
</template>

<script>
	// Utilities
	import { get } from 'vuex-pathify'
	import ModifyProfile from '@/views/agent/ModifyProfile.vue'

	export default {
		name: 'AccountPendingView',
		components: {
			'modify-profile': ModifyProfile,
		},
		data: () => ({
			dialogUser: false,
			selectedUser: {},
		}),
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			rejectReason() {
				var user = this.getCurrentUser
				return `${user.userData?.metaData?.rejectReason || ''}`
			},
			message() {
				return this.$route.params.status == 0 ? 'حساب کاربری شما در وضعیت انتظار بررسی مدیر می باشد و تا زمان تایید مدارک لطفا منتظر فعال شدن حساب خود باشید.'
					: 'حساب کاربری شما رد تایید شده است.'
			},
			icon() {
				return this.$route.params.status == 0 ? 'mdi-timer-sand' : 'mdi-cancel'
			},
			color() {
				return this.$route.params.status == 0 ? 'orange' : 'red'
			}
		},
		mounted() {

		},
		methods: {
			showProfile() {
				var user = this.getCurrentUser
				if (!user || !user.userData) { return }
				this.selectedUser = { id: user.userData.id }
				this.dialogUser = true
				this.$nextTick(() => {
					this.$refs.modifyProfile.prepareData()
				})
			},
			callbck_userprofile(result) {
				this.dialogUser = false
			},
		}
	}
</script>
<style></style>
